import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../shared/api/client';

/* ───────────────────────────────────────────────────────────────────────────
   Contrato — GET /fiscal/ibs-cbs (FiscalAnalyticsController)

   Espelha `IbsCbsByNcmResult` (application/queries/get-ibs-cbs-by-ncm
   .query.ts). Estimativa da carga IBS/CBS por NCM usando a tabela de
   transição da reforma (2026→2033) e as alíquotas legadas configuradas.

   Query params (IbsCbsByNcmQueryDto):
     - year? (padrão 2026), ncmPrefix?, uf? (padrão SP), page (padrão 1),
       limit (padrão 50, máx 200)

   O tenant vem da sessão.
   ─────────────────────────────────────────────────────────────────────────── */

export interface IbsCbsNcmLine {
  ncm: string;
  descricao: string;
  icmsAliquota: number;
  pisAliquota: number;
  cofinsAliquota: number;
  icmsPisCofinsTotalPct: number;
  ibsEstPct: number;
  cbsEstPct: number;
  ibsCbsTotalPct: number;
  transitionYear: number;
  transitionPercent: number;
  hasConfiguredRates: boolean;
  reducaoIbsPct: number | null;
  reducaoCbsPct: number | null;
  acoes: string[];
}

export interface TransitionPeriod {
  year: number;
  transitionPercent: number;
  ibsEstPct: number;
  cbsEstPct: number;
}

export interface IbsCbsByNcm {
  data: IbsCbsNcmLine[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  year: number;
  transitionComparativo: TransitionPeriod[];
}

export interface IbsCbsQuery {
  year?: number;
  ncmPrefix?: string;
  uf?: string;
  page?: number;
  limit?: number;
}

export function useIbsCbs(params?: IbsCbsQuery) {
  return useQuery({
    queryKey: ['fiscal', 'ibs-cbs', params] as const,
    queryFn: () =>
      apiClient.get<IbsCbsByNcm>('/fiscal/ibs-cbs', {
        params: {
          page: String(params?.page ?? 1),
          limit: String(params?.limit ?? 50),
          ...(params?.year ? { year: String(params.year) } : {}),
          ...(params?.ncmPrefix ? { ncmPrefix: params.ncmPrefix } : {}),
          ...(params?.uf ? { uf: params.uf } : {}),
        },
      }),
  });
}